import esEmail from "./locales/es/email.json";
import enEmail from "./locales/en/email.json";
import itEmail from "./locales/it/email.json";
import esInvoice from "./locales/es/invoice.json";
import enInvoice from "./locales/en/invoice.json";
import itInvoice from "./locales/it/invoice.json";
// Exportamos los objetos de recursos directamente
export const EMAIL_LOCALES = {
  es: { email: esEmail, invoice: esInvoice },
  en: { email: enEmail, invoice: enInvoice },
  it: { email: itEmail, invoice: itInvoice },
} as const;

// Opcional: exportar tipos útiles por si el backend quiere tipar las traducciones
export type EmailTranslations = typeof esEmail;
